export default __webpack_public_path__ + "static/media/payments.bfa30845.svg";